import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appConfig } from "@/config/appConfig";

const routeTitles: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/login": "Login",
  "/callback": "Signing In",
  "/employee": "My Leaves",
  "/manager": "Approvals",
  "/hr": "HR Portal",
  "/hr/employees": "Employees",
  "/hr/holidays": "Holidays",
  "/reports": "Reports",
  "/hr/upload": "Upload Data",
  "/leave-quotas": "Manage Leave Quota",
  "/teams": "Manage Teams",
  "/calendar": "Calendar",
  "/account-settings": "Account Settings",
  "/forgot-password": "Forgot Password",
  "/reset-password": "Reset Password",
};

export function PageTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const orgName = appConfig.orgName;
    const path = location.pathname;
    const pageTitle = routeTitles[path] || appConfig.appTitle;

    if (pageTitle === appConfig.appTitle) {
      document.title = pageTitle;
    } else {
      document.title = `${pageTitle} - ${orgName}`;
    }

    // Handle titles for routes that might have sub-paths or query params if needed
    // For now, exact match is fine, or we can add logic for dynamic segments
  }, [location]);

  return null;
}
